import classNames from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';

import {
  Text,
  Email,
  Select,
} from 'hb-react/shared/components/formik/components/inputs';
import { withFeatureFlag } from 'hb-react/shared/hooks/useFeatureFlag';

import Dedications from './Dedications';
import CustomAttributes from '../CustomAttributes';
import SectionTitle from '../SectionTitle';
import UserCustomAttributes from '../UserCustomAttributes';

class Contact extends Component {
  renderField = (Component, { fieldId, mandatory, className } = {}) => {
    const {
      order: {
        meta: { user_fields_config: userFieldsConfig },
      },
    } = this.props;
    const field = userFieldsConfig[fieldId];

    return mandatory || field.donation_display ? (
      <div className={classNames('grid__item', className)}>
        <Component
          name={`donation_order[${fieldId}]`}
          validate={{
            required: mandatory || field.donation_require,
            maxLength: 255,
          }}
          label={field.name}
          placeholder={field.placeholder || field.name}
        />
      </div>
    ) : null;
  };

  renderBillingAddress = () => {
    const { countries } = this.props;

    return (
      <>
        <div className="grid__item one-whole">
          <Text
            name="donation_order[billing_address_attributes][address_1]"
            validate={{
              required: true,
              maxLength: 255,
            }}
            label={__('Address 1')}
            placeholder={__('Address 1')}
          />
        </div>
        <div className="grid__item one-half palm--one-whole">
          <Text
            name="donation_order[billing_address_attributes][address_2]"
            validate={{
              maxLength: 255,
            }}
            label={__('Address 2')}
            placeholder={__('Address 2')}
          />
        </div>
        <div className="grid__item one-half palm--one-whole">
          <Text
            name="donation_order[billing_address_attributes][address_3]"
            validate={{
              maxLength: 255,
            }}
            label={__('Address 3')}
            placeholder={__('Address 3')}
          />
        </div>
        <div className="grid__item one-half palm--one-whole">
          <Text
            name="donation_order[billing_address_attributes][city]"
            validate={{
              required: true,
              maxLength: 255,
            }}
            label={__('City')}
            placeholder={__('City')}
          />
        </div>
        <div className="grid__item one-half palm--one-whole">
          <Text
            name="donation_order[billing_address_attributes][state]"
            validate={{
              maxLength: 255,
            }}
            label={__('State')}
            placeholder={__('State')}
          />
        </div>
        <div className="grid__item one-half palm--one-whole">
          <Text
            name="donation_order[billing_address_attributes][postal_code]"
            validate={{
              required: true,
              maxLength: 255,
            }}
            label={__('Postal code')}
            placeholder={__('Postal code')}
          />
        </div>
        <div className="grid__item one-half palm--one-whole">
          <Select
            name="donation_order[billing_address_attributes][country]"
            type="countries"
            validate={{
              required: true,
            }}
            label={__('Country')}
            placeholder={__('Country')}
            options={countries}
          />
        </div>
      </>
    );
  };

  render() {
    const {
      advancedOptionsEnabled,
      order: {
        campaign: {
          ask_for_tax_number: askForTaxNumber,
          customizable_attributes: customizableAttributes,
          enable_dedication: enableDedication,
          require_dedication_info: requireDedicationInfo,
        },
        meta: { user_custom_attributes: userCustomAttributes },
      },
    } = this.props;

    return (
      <>
        <SectionTitle title={__('Your information')} mb={10} />
        <div className="grid push--bottom">
          {this.renderField(Text, {
            fieldId: 'firstname',
            className: 'one-half palm--one-whole',
            mandatory: true,
          })}
          {this.renderField(Text, {
            fieldId: 'prefix_name',
            className: 'one-half palm--one-whole',
          })}
          {this.renderField(Text, {
            fieldId: 'lastname',
            className: 'one-half palm--one-whole',
            mandatory: true,
          })}
          {this.renderField(Text, {
            fieldId: 'maidenname',
            className: 'one-half palm--one-whole',
          })}
          {this.renderField(Email, {
            fieldId: 'email',
            className: 'one-half palm--one-whole',
            mandatory: true,
          })}
          {this.renderBillingAddress()}
          {this.renderField(Text, {
            fieldId: 'mobile_perso',
            className: 'one-half palm--one-whole',
          })}
          {this.renderField(Text, {
            fieldId: 'mobile_pro',
            className: 'one-half palm--one-whole',
          })}
        </div>

        {advancedOptionsEnabled && !isEmpty(userCustomAttributes) && (
          <div className="grid push--bottom">
            <UserCustomAttributes userCustomAttributes={userCustomAttributes} />
          </div>
        )}
        {advancedOptionsEnabled && !isEmpty(customizableAttributes) && (
          <div className="grid push--bottom">
            <CustomAttributes customAttributes={customizableAttributes} />
          </div>
        )}

        {askForTaxNumber && (
          <div className="grid push--bottom">
            <div className="grid__item one-whole">
              <Text
                name="donation_order[tax_number]"
                validate={{
                  required: true,
                  maxLength: 255,
                }}
                label={s__('Donations|Tax number')}
                placeholder={s__('Donations|Tax number')}
              />
            </div>
          </div>
        )}

        {enableDedication && (
          <div className="push-double--bottom">
            <Dedications isRequired={requireDedicationInfo} />
          </div>
        )}
      </>
    );
  }
}

Contact.propTypes = {
  order: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired,
  advancedOptionsEnabled: PropTypes.bool.isRequired,
};

export default withFeatureFlag(Contact);
